import { EventDispatcher, IAssetHandle, Sound, SoundResource, View, asset, inject, subscription, view } from "@spawn/core";
import { GoldenBonusService } from "@spawn/golden-bonus";
import {
	PartyService,
	PlayWinSoundEvent,
	ReelController,
	StopWinSoundEvent,
	WinPartyEvents,
	WinSignState,
	WinSoundEvents,
} from "@spawn/slot-machine";
import { Subscription, filter } from "rxjs";
import { BaseSymbolTypes } from "../services/symbolService";

@view
export class MariachiWinSoundView extends View {
	@asset(SoundResource) mariachiSoundResource!: IAssetHandle<SoundResource>;

	@inject protected eventDispatcher!: EventDispatcher;
	@inject protected partyService!: PartyService;
	@inject protected goldenBonusService!: GoldenBonusService;
	@inject protected reelController!: ReelController;

	@subscription subscriptions: Subscription[] = [];

	private mariachiSound!: Sound;

	constructor() {
		super();

		this.init();
	}

	protected init(): void {
		this.mariachiSound = new Sound(this.mariachiSoundResource());
		this.subscribeToEvents();
	}

	protected subscribeToEvents(): void {
		this.subscriptions.push(
			this.eventDispatcher
				.event$<PlayWinSoundEvent | StopWinSoundEvent>(WinPartyEvents.WinSound)
				.pipe(filter((_) => this.isMariachiSmallWin()))
				.subscribe((event) => {
					if (event.payload.eventType === WinSoundEvents.PlayWinSound) {
						this.play();
					}
					if (event.payload.eventType === WinSoundEvents.StopWinSound) {
						this.stop();
					}
				}),
			this.eventDispatcher.event$(WinPartyEvents.StopWinParty).subscribe(() => this.stop())
		);
	}

	protected isMariachiSmallWin(): boolean {
		// ignore if not small win
		if (this.partyService.winFactor >= this.partyService.winFactorRanges[WinSignState.Nice][0]) {
			return false;
		}

		const normalCoordinates = this.partyService.paylineWins.flatMap((payline) => payline.symbolCoordinates);
		const bonusCoordinates = this.goldenBonusService.getBonusSymbols().map((bonus) => bonus.position);
		return [...normalCoordinates, ...bonusCoordinates].some(
			(coordinate) => this.reelController.getSlotFace()[coordinate.x][coordinate.y] === BaseSymbolTypes.HV1
		);
	}

	public play(): void {
		void this.mariachiSound.play();
	}

	public stop(): void {
		void this.mariachiSound.stop();
	}
}
